import { render, staticRenderFns } from "./RiwayatBerlangganan.vue?vue&type=template&id=0533f306&scoped=true&"
import script from "./RiwayatBerlangganan.vue?vue&type=script&lang=js&"
export * from "./RiwayatBerlangganan.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatBerlangganan.vue?vue&type=style&index=0&id=0533f306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533f306",
  null
  
)

export default component.exports